// @flow
import React from 'react';
import { Link, matchPath, withRouter } from 'react-router-dom';
import { Icon } from '@elements';
import { map, forEach, isEmpty, get } from 'lodash';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { createNsTranslator, fsPrintf } from '@helpers/helpers';
import { compose } from 'redux';
import classnames from 'classnames';
import { blockedLinkTo } from '../../../routes/blockedAccess';
import './AppMobileFooter.scss';

type Props = {
  location: Object,
  t: Function,
  blocked: boolean,
  subscriptionStatus: ?string,
};

type State = {
  keyboardVisible: boolean,
};

const menuItens = (_: Function) => [
  {
    match: ['/agenda'],
    text: _('label/agenda'),
    icon: 'calendar',
    linkTo: '/agenda',
  },
  {
    match: ['/pacientes/lista', '/paciente/:id/prontuario'],
    text: _('label/patients'),
    icon: 'contacts',
    linkTo: '/pacientes/lista',
  },
  {
    match: ['/relatorios', '/relatorios/:anyroute'],
    text: _('label/reports'),
    icon: 'reports',
    linkTo: '/relatorios',
  },
  {
    match: ['/ajustes'],
    text: _('label/settings'),
    icon: 'settings',
    linkTo: '/ajustes',
  },
];

class AppMobileFooter extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      keyboardVisible: false,
    };
  }
  componentWillMount() {
    window.addEventListener('keyboardDidShow', this.handleKeyboardShow);
    window.addEventListener('keyboardDidHide', this.handleKeyaboardHide);
  }

  componentWillUnmount() {
    window.removeEventListener('keyboardDidShow', this.handleKeyboardShow);
    window.removeEventListener('keyboardDidHide', this.handleKeyaboardHide);
  }

  render() {
    const _ = createNsTranslator('layout', this.props.t);

    if (this.state.keyboardVisible) {
      return null;
    }

    return (
      <div className="appMobileFooter">
        <ul>
          {map(menuItens(_), (item, index:number) => {
            const { to, closed } = this.linkTo(item);
            return (
              <li className={classnames(this.isActiveClass(item.match), { closed })} key={index}>
                {item.onClick && (
                  <a onClick={item.onClick}>
                    <Icon iconName={item.icon} size={18} />
                    <span>{item.text}</span>
                  </a>
                )}
                {!item.onClick && (
                  <Link to={to} className={this.isActiveClass(item.match)} aria-label={closed ? _('label/closed_tab', null, fsPrintf(item.text)) : undefined}>
                    <Icon iconName={item.icon} size={18} />
                    {closed && <Icon iconName="lock" size={10} className="closedLock" />}
                    <span>{item.text}</span>
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  // A tab the account can't open (no active subscription) goes straight to Meu plano (blockedLinkTo)
  linkTo = (item: Object) => {
    const { blocked, subscriptionStatus } = this.props;
    return blockedLinkTo(get(item, 'linkTo'), { blocked, subscriptionStatus });
  };

  handleKeyboardShow= () => this.setState({ keyboardVisible: true });

  handleKeyaboardHide= () => this.setState({ keyboardVisible: false });

  isActiveClass = (matches: Array<string>) => {
    let count = 0;

    forEach(matches, route => {
      const match = matchPath(this.props.location.pathname, {
        path: route,
        exact: false,
      });

      if (!isEmpty(match)) {
        count++;
      }
    });
    return count > 0 ? 'active' : '';
  };
}


const mapStateToProps = (state, ownProps) => ({
  user: get(state, ['context', 'user']),
  location: get(ownProps, ['location']),
  blocked: get(state, ['context', 'user', 'advancedData', 'blocked'], false),
  subscriptionStatus: get(state, ['context', 'user', 'advancedData', 'subscriptionStatus']),
});

export default compose(
  withRouter,
  withTranslation(),
  connect(mapStateToProps),
)(AppMobileFooter);
